import type { CodeDefinition } from '../../../../js/api';

/**
 * Categories commonly needed to resolve choice labels on facility dynamic fields.
 * Keep in sync with FacilityDrawer / facility edit flows.
 */
export const FACILITY_DISPLAY_CODE_CATEGORIES = [
  'FacilityTypes',
  'HospitalOwnershipChoices',
  'EMRChoices',
  'FacilityContactRoles',
  'Specialty',
] as const;

export function enrichDynamicFieldsWithChoices(
  fields: any[] | undefined | null,
  codeDefinitionsByCategory: Record<string, CodeDefinition[]> | undefined | null
): any[] {
  if (!fields || !codeDefinitionsByCategory) {
    return [];
  }

  return fields.map((field) => {
    if (field.choices_category) {
      const categoryDefs = codeDefinitionsByCategory[field.choices_category] || [];
      const choices = categoryDefs.map((def) => ({ code: def.code, title: def.title }));
      return { ...field, choices };
    }
    return field;
  });
}
